import React, { useState, useEffect } from 'react';
import { Table, Pagination, Button, Form, ButtonGroup } from 'react-bootstrap';
import { Filter, EyeFill, PencilFill, TrashFill } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';
import FiltrosPagosRes from '../../../PagosResibidos/componentes/filtroPagosRes';
import EditarPagoRes from '../../../PagosResibidos/componentes/editarPagoRes';
import AlertsPagosRecibidos from '../../../PagosResibidos/componentes/Utils/AlertsPagosRecibidos';
import APIserver from '../../../../../api/axiosConfig';

function IngresosTabla({ bancoId }) {
    const [showFilters, setShowFilters] = useState(true);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [editShow, setShowEdit] = useState(false);
    const [pagoToEdit, setPagoToEdit] = useState(null); // Estado para almacenar el pago a editar
    const [pagos, setPagos] = useState([]); // Estado para almacenar los pagos recibidos
    const [currentPage, setCurrentPage] = useState(1); // Estado para la página actual de la paginación
    const [hasMore, setHasMore] = useState(true); // Estado para verificar si hay más datos
    const [filters, setFilters] = useState({}); // Estado para los filtros

    useEffect(() => {
        fetchPagos();
    }, [rowsPerPage, currentPage, filters, bancoId]); // Añadir bancoId a las dependencias

    const fetchPagos = async () => {
        try {
            const response = await APIserver.get(`/api/mostrar/pagos`, {
                params: {
                    limit: rowsPerPage,
                    offset: (currentPage - 1) * rowsPerPage,
                    ...filters,
                    banco: bancoId // Añadir el bancoId a los parámetros de consulta
                }
            });
            const { results, hasMore } = response.data;
            setPagos(results);
            setHasMore(hasMore);
        } catch (error) {
            console.error('Error al obtener los pagos:', error);
        }
    };

    const handleSearch = (newFilters) => {
        setFilters(newFilters);
        setCurrentPage(1); // Resetear a la primera página al aplicar filtros
    };

    const handleClear = () => {
        setFilters({});
        setCurrentPage(1); // Resetear a la primera página al limpiar filtros
    };

    const toggleFilters = () => {
        setShowFilters(!showFilters);
    };

    const handleChangeRowsPerPage = (e) => {
        setRowsPerPage(parseInt(e.target.value));
        setCurrentPage(1); // Resetear a la primera página al cambiar el número de filas por página
    };

    const handleEditClose = () => {
        setShowEdit(false);
        setPagoToEdit(null); // Limpiar los datos del pago al cerrar el modal
    };

    const handleEditShow = (pago) => {
        setPagoToEdit(pago); // Establecer el pago a editar
        setShowEdit(true);
    };

    const handleDelete = (idPago) => {
        AlertsPagosRecibidos.showDeleteConfirmation(idPago, async () => {
            try {
                await APIserver.delete(`/api/pagosrecibidos/pagos/${idPago}`);
                AlertsPagosRecibidos.showDeleteConfirmationserver();
                fetchPagos(); // Refrescar la lista después de la eliminación
            } catch (error) {
                AlertsPagosRecibidos.showDeleteErrorMessage();
                console.error('Error al eliminar el pago:', error);
            }
        });
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getUTCDate()).padStart(2, '0');
        const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Los meses son de 0 a 11
        const year = date.getUTCFullYear();
        return `${day}/${month}/${year}`;
    };

    return (
        <div style={{ boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.1)" }}>
            <Table responsive className='text-center align-middle border'>
                <thead>
                    <tr>
                        <th colSpan={8}>
                            <div className='d-flex justify-content-between align-items-center'>
                                <div className='d-flex flex-wrap'>
                                    <Button variant='link' size='sm' onClick={toggleFilters} title='filtrar'>
                                        <Filter className='m-0 text-danger' size={20} />
                                    </Button>
                                </div>
                                <div>
                                    <Form.Select
                                        className='ms-2'
                                        value={rowsPerPage}
                                        onChange={handleChangeRowsPerPage}
                                    >
                                        <option value='5'>5</option>
                                        <option value='10'>10</option>
                                        <option value='20'>20</option>
                                        <option value='50'>50</option>
                                    </Form.Select>
                                </div>
                            </div>
                            <div className={`filter-options ${showFilters ? 'show' : ''}`}>
                                {/* FILTROS DE TABLA */}
                                <FiltrosPagosRes onSearch={handleSearch} onClear={handleClear} />
                            </div>
                        </th>
                    </tr>
                    <tr>
                        <th>Pago</th>
                        <th>Factura</th>
                        <th>Cliente</th>
                        <th>Observaciones</th>
                        <th>Creacion</th>
                        <th>Cuenta</th>
                        <th>Monto</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {pagos.map((pago) => (
                        <tr key={pago.idPago}>
                            <td>
                                <Link to={`/admin/PagosRecibidos/DetallesPago/${pago.idPago}/`} className='text-decoration-none'>
                                    {pago.numPagoRe}
                                </Link>
                            </td>
                            <td>
                                <Link to={`/admin/Facturas/DetallesFactura/${pago.idFacV}/`} className='text-decoration-none'>
                                    {pago.numFacV}
                                </Link>
                            </td>
                            <td>
                                <Link to={`/admin/Clientes/DetallesClientes/${pago.idCliente}/`} className='text-decoration-none'>
                                    {pago.nomCliente}
                                </Link>
                            </td>
                            <td>{pago.detalle}</td>
                            <td>{formatDate(pago.fecha)}</td>
                            <td>{pago.nomBanco}</td>
                            <td>${pago.monto.toLocaleString()}</td>
                            <td>
                                <ButtonGroup aria-label='action-button'>
                                    <Link to={`/admin/PagosRecibidos/DetallesPago/${pago.idPago}/`}>
                                        <Button variant='link' className='text-dark' title='ver pago'>
                                            <EyeFill size={18} />
                                        </Button>
                                    </Link>
                                    <Button 
                                        variant='link' 
                                        className='text-warning' 
                                        title='editar pago' 
                                        onClick={() => handleEditShow(pago)}
                                    >
                                        <PencilFill size={18} />
                                    </Button>
                                    <Button variant='link' className='text-danger' title='eliminar pago' onClick={() => handleDelete(pago.idPago)}>
                                        <TrashFill size={18} />
                                    </Button>
                                </ButtonGroup>
                            </td>
                        </tr>
                    ))}
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan={8}>
                            <div className='d-flex justify-content-center align-items-center'>
                                <Pagination>
                                    <Pagination.Prev disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)} />
                                    <Pagination.Item active>{currentPage}</Pagination.Item>
                                    <Pagination.Next disabled={!hasMore} onClick={() => setCurrentPage(currentPage + 1)} />
                                </Pagination>
                            </div>
                        </td>
                    </tr>
                </tfoot>
            </Table>
            {/* Modal Editar Pago */}
            <EditarPagoRes 
                show={editShow} 
                handleClose={handleEditClose} 
                pago={pagoToEdit} // Pasar el pago a editar
                fetchPagos={fetchPagos} // Pasar la función fetchPagos para actualizar la lista
            />
        </div>
    );
}

export default IngresosTabla;
